<template>

  <div class="app-container">

    <el-card ref="searchBox" class="mb20 mt20 ml20 mr20 ta-l" v-show="showSearch">
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
        <el-form-item label="印章名称" prop="sealName">
          <el-input
              v-model="queryParams.sealName"
              placeholder="请输入印章名称"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="印章编码" prop="sealCode">
          <el-input
              v-model="queryParams.sealCode"
              placeholder="请输入印章编码"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="刻企名称" prop="extMaker" v-if="orgCode === '91210204341167191F'">
          <el-input
              v-model="queryParams.extMaker"
              placeholder="请输入刻企名称"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="订单编号" prop="kqTradeNo">
          <el-input
              v-model="queryParams.kqTradeNo"
              placeholder="请输入订单编号"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="印章类型" prop="sealName">
          <el-select v-model="queryParams.sealType" style="width: 240px" clearable placeholder="请选择">
            <el-option
                v-for="item in sealData"
                :key="item.code"
                :label="item.name"
                :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="sealStatus">
          <el-select v-model="queryParams.sealStatus" style="width: 240px" clearable placeholder="请选择">
            <el-option
                v-for="item in statusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="mb20 mt20 ml20 mr20 ta-l">
      <div>
        <div class="button-box flex-center-end" ref="buttonBox">
          <right-toolbar :showSearch.sync="showSearch" @queryTable="handleQuery" :columns.sync="columns"
                         storageKey="xxxxxxxx" @getColumns="getColumns"></right-toolbar>
        </div>
        <el-table
            ref="table"
            :key="tableKey"
            v-loading="loading"
            :data="tableData"
            style="width: 100%"
            :height="getDynamicStyles(showSearch)"
        >
          <el-table-column
              v-if="columns.sealCode.visible"
              :show-overflow-tooltip="true"
              prop="sealCode"
              label="印章编码"
              width="180">
          </el-table-column>
          <el-table-column
              v-if="orgCode === '91210204341167191F'"
              prop="extMaker"
              label="刻章企业"
              width="180">
            <template slot-scope="scope">
              {{ scope.row.extMaker ? keepChinese(scope.row.extMaker) : '' }}
            </template>
          </el-table-column>
          <el-table-column
              v-if="columns.sealName.visible"
              prop="sealName"
              label="印章名称"
              width="250">
          </el-table-column>
          <el-table-column
              v-if="columns.sealType.visible"
              prop="sealType"
              label="印章类型"
              align="center"
              width="150">
            <template slot-scope="scope">
              <el-tag size="small" v-for="(item,index) in sealData" :key="index" v-if="item.code == scope.row.sealType">
                {{ item.name }}
              </el-tag>
              <el-tag v-if="scope.row.sealType === '99'">手写签名章</el-tag>
            </template>
          </el-table-column>
          <el-table-column
              v-if="columns.sealWidth.visible"
              prop="sealWidth"
              label="印章宽度"
              align="center"
              width="90">
          </el-table-column>
          <el-table-column
              v-if="columns.sealHeight.visible"
              prop="sealHeight"
              label="印章高度"
              align="center"
              width="90">
          </el-table-column>
          <el-table-column
              v-if="columns.sealStatus.visible"
              prop="sealStatus"
              label="状态"
              align="center"
              width="70">
            <template slot-scope="scope">
              <el-tag type="warning" v-if="scope.row.sealStatus == 0" size="small">待制作</el-tag>
              <el-tag type="danger" v-if="scope.row.sealStatus == 9" size="small">注销</el-tag>
              <el-tag type="success" v-if="scope.row.sealStatus == 1" size="small">正常</el-tag>
            </template>
          </el-table-column>
          <el-table-column
              v-if="columns.uid.visible"
              prop="uid"
              label="设备编码"
              width="180">
            <template slot-scope="scope">
              <div v-if="scope.row.uid == '0000'">
                <el-tag size="small">云章</el-tag>
              </div>
              <div v-else-if="scope.row.uid == '1111'"></div>
              <div v-else>{{ scope.row.uid.split('~')[1] }}</div>
            </template>
          </el-table-column>
          <el-table-column
              v-if="columns.kqTradeNo.visible"
              prop="kqTradeNo"
              label="订单编号"
              width="140">
          </el-table-column>
          <el-table-column
              v-if="columns.remark.visible"
              prop="remark"
              label="备注"
              width="180">
          </el-table-column>
          <el-table-column
              v-if="columns.sealValidBegin.visible"
              prop="sealValidBegin"
              label="印章有效起始时间"
              width="140">
          </el-table-column>
          <el-table-column
              v-if="columns.sealValidEnd.visible"
              prop="sealValidEnd"
              label="印章有效截止时间"
              width="140">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.annualFlag == '1'" type="danger" size="small">{{
                  scope.row.sealValidEnd
                }}
              </el-tag>
              <div v-else>{{ scope.row.sealValidEnd }}</div>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              align="center"
              label="操作"
              width="150">
            <template slot-scope="scope">
              <el-popconfirm
                  class="ml10"
                  confirm-button-text="微信支付"
                  cancel-button-text="支付宝支付"
                  @confirm="annualInspection(scope.row, 'wxpay')"
                  @cancel="annualInspection(scope.row, 'alipay')"
                  v-if="scope.row.sealStatus == 1 && scope.row.annualFlag == '1'"
                  :title="'是否确认年检印章 ：' + scope.row.sealName + '?'"
              >
                <el-button style="color: #f56c6c !important;" size="mini" type="text" slot="reference">年检</el-button>
              </el-popconfirm>

              <el-popconfirm
                  class="ml10"
                  v-if="scope.row.sealStatus == 1"
                  @confirm="handleCancel(scope.row)"
                  :title="'是否确认注销印章 ：' + scope.row.sealName + '?'"
              >
                <el-button size="mini" type="text" slot="reference">注销</el-button>
              </el-popconfirm>

              <el-popconfirm
                  class="ml10"
                  v-if="scope.row.sealStatus == 0"
                  @confirm="handleDel(scope.row)"
                  :title="'是否确认删除 ：' + scope.row.sealName + '?'"
              >
                <el-button size="mini" type="text" slot="reference">删除</el-button>
              </el-popconfirm>

              <el-popconfirm
                  class="ml10"
                  v-if="scope.row.sealStatus == 1"
                  @confirm="handleDownProof(scope.row)"
                  :title="'是否确认下载 ：' + scope.row.sealName + '的备案证明?'"
              >
                <el-button size="mini" type="text" slot="reference">备案证明</el-button>
              </el-popconfirm>

              <!--              orgCode === '91210204341167191F' && -->
              <el-popconfirm
                  v-if="orgCode === '91210204341167191F' && scope.row.uid != '0000' && scope.row.sealStatus == 0"
                  class="ml10"
                  @confirm="getUkey(scope.row)"
                  :title="'是否确认绑定印章 ：' + scope.row.sealName + '?'"
              >
                <!--                <el-button slot="reference">删除</el-button>-->
                <el-button size="mini" type="text" slot="reference">绑k</el-button>
              </el-popconfirm>

              <el-popconfirm
                  v-if="orgCode === '91210204341167191F' && scope.row.sealStatus == 0"
                  class="ml10"
                  @confirm="doMakeNowSeal(scope.row)"
                  :title="'是否确认制作印章 ：' + scope.row.sealName + '?'"
              >
                <el-button size="mini" type="text" slot="reference">制作</el-button>
              </el-popconfirm>

              <el-button v-if="orgCode === '91210204341167191F'" class="ml10" size="mini" type="text"
                         @click="handleCheck(scope.row)">查看
              </el-button>

            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container" ref="pagination">
          <pagination
              :total="total"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="getMakeSealList"

          />
        </div>
      </div>

      <orderDetails
          ref="details"
      />

      <pay-dialog
          v-if="payVisible"
          :visible.sync="payVisible"
          :payList="payList"
          :type="payList.payType"
          @closeAll="closeAll"
      />

    </el-card>

  </div>

</template>

<script>
import Cookie from "js-cookie";
import {enumDevice} from '@/utils/Ukey'
import axios from 'axios'
import orderDetails from "@/pages/customerEnterprise/list/components/orderDetails.vue";
import {getDynamicStyles} from "@/utils/ruoyi";
import PayDialog from "@/pages/customerEnterprise/list/components/payDialog.vue";

export default {
  name: "list",
  components: {PayDialog, orderDetails},
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      // 遮罩层
      loading: true,
      //
      showSearch: true,
      payVisible: false,
      payList: {},
      // 总条数
      total: 0,

      tableKey: 0,

      tableData: [],

      sealData: [],

      statusOption: [
        {
          value: '0',
          label: '待制作'
        },
        {
          value: '1',
          label: '正常'
        },
        {
          value: '9',
          label: '注销'
        },
      ],

      userInfo: {},
      orgCode: '',
      columns: {
        sealCode: {label: '印章编码', visible: true},
        sealName: {label: '印章名称', visible: true},
        sealType: {label: '印章类型', visible: true},
        sealWidth: {label: '印章宽度', visible: false},
        sealHeight: {label: '印章高度', visible: false},
        sealStatus: {label: '状态', visible: true},
        uid: {label: '设备编码', visible: true},
        kqTradeNo: {label: '订单编号', visible: true},
        remark: {label: '备注', visible: true},
        sealValidBegin: {label: '印章有效起始时间', visible: true},
        sealValidEnd: {label: '印章有效截止时间', visible: true},
      }
    }
  },
  created() {
    this.orgCode = Cookie.get('orgCode')
    this.getSealType()
    this.handleQuery()
  },
  methods: {
    getDynamicStyles,
    closeAll() {
      this.payVisible = false
      this.getMakeSealList()
    },
    getColumns(e) {
      this.tableKey += 1
      this.$set(this, 'columns', e)
    },
    handleCheck(e) {
      this.$refs.details.show(e);
    },

    keepChinese(str) {
      return str.replace(/[^\u4e00-\u9fff]/g, '');
    },
    handleDownProof(item) {
      let token = this.$auth.getKqToken();
      let fileUrl = ''
      fileUrl = this.baseUrl + this.$api.user.downProof + '?sealCode=' + item.sealCode
      axios({
        url: fileUrl,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
        responseType: 'blob', // 设置响应类型为blob
      }).then(response => {
        const blob = new Blob([response.data]);
        const fileName = item.sealCode + '备案证明.pdf';
        console.log(fileName)
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
      }).catch(err => {
        this.$message.error(err.data.msg)
      })
    },
    // 年检
    annualInspection(e, payType) {
      this.payList = {
        id: e.id,
        payType: payType
      }
      this.payVisible = true
      // this.loading = true
      // this.$http.post(this.$api.customerEnterprise.annualSurvey, {id: e.id, payType: payType}).then(res => {
      //   if (res.data.code == 200) {
      //     this.$message.success("年检成功");
      //     // this.getMakeSealList()
      //   } else {
      //     this.loading = false
      //     this.$message.error(res.data.msg)
      //   }
      // })
    },
    // 注销
    handleCancel(e) {
      this.loading = true
      this.$http.post(this.$api.customerEnterprise.deactivateSeal, {id: e.id}).then(res => {
        if (res.data.code == 200) {
          this.$message.success("注销成功");
          this.getMakeSealList()
        } else {
          this.loading = false
          this.$message.error(res.data.msg)
        }
      })
    },
    // 删除
    handleDel(e) {
      this.loading = true
      this.$http.post(this.$api.customerEnterprise.deleteSealById, {id: e.id}).then(res => {
        if (res.data.code == 200) {
          this.$message.success("删除成功");
          this.getMakeSealList()
        } else {
          this.loading = false
          this.$message.error(res.data.msg)
        }
      })
    },
    doMakeNowSeal(e) {
      this.loading = true
      this.$http.post(this.$api.customerEnterprise.doMakeNowSeal, {id: e.id}).then(res => {
        if (res.data.code == 200) {
          this.$message.success("制作成功");
          this.getMakeSealList()
        } else {
          this.loading = false
          this.$message.error(res.data.msg)
        }
      })
    },
    getUkey(e) {
      let ukey = enumDevice()
      if (!ukey) {
        this.$message.error('未找到ukey')
      } else {
        this.loading = true
        this.$http.get(this.$api.customerEnterprise.doMakeESealNow, {id: e.id, uid: ukey}).then(res => {
          if (res.data.code == 200) {

            setTimeout(() => {
              this.$message.success("绑定成功");
              this.getMakeSealList()
            }, 5000)

          }
        })
      }
    },
    getSealType() {
      this.$http.post(this.$api.user.getSealType, {type: "business"}, {"Content-Type": "application/x-www-form-urlencoded"}).then(res => {
        if (res.data.code == 200) {
          this.sealData = res.data.data || []
        }
      })
    },
    getMakeSealList() {
      this.loading = true
      this.$http.get(this.$api.customerEnterprise.getMakeSealList, this.queryParams).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.rows
          this.total = res.data.total
          this.loading = false;
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getMakeSealList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
      },
          this.handleQuery();
    },
  }
}
</script>

<style scoped lang="less">

</style>
